import { SpinnerService } from '@/services/spinner.service';
import Helpers from '@/shared/helpers';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChange,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-blocker',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './blocker.component.html',
})
export class BlockerComponent implements OnChanges, OnDestroy {
  private timeout: ReturnType<typeof setTimeout> | null = null;
  spinnerSubscription: Subscription;
  @Input() blocked: boolean = false;
  @Input() messageVisible: boolean = false;
  @Input() displayMessageAfter: number = 30 * 1000;
  @Output() onClose = new EventEmitter<boolean>();

  private helpers: Helpers;

  constructor(
    private spinnerService: SpinnerService,
    private translocoService: TranslocoService,
  ) {
    this.spinnerSubscription = this.spinnerService.spinnerObserver.subscribe({
      next: (show) => (this.blocked = show),
    });

    this.helpers = Helpers.getInstance(this.translocoService);
  }

  ngOnChanges(changes: SimpleChanges) {
    const currentItem: SimpleChange = changes.blocked;
    currentItem && this.startCountDown();
  }

  startCountDown(): void {
    this.cleanUp();

    if (this.displayMessageAfter <= 0) return;

    this.timeout = setTimeout(() => {
      this.messageVisible = true;
    }, this.displayMessageAfter);
  }

  unBlock() {
    this.cleanUp();
    this.blocked = false;
    this.onClose.emit(false);
  }

  ngOnDestroy(): void {
    if (this.spinnerSubscription) {
      this.spinnerSubscription.unsubscribe();
    }
  }

  private cleanUp() {
    this.messageVisible = false;
    this.timeout && clearTimeout(this.timeout);
  }
}
